(function(doc) {
  /**
   * フェードイン処理
   */
  const initFadein = () => {
    const targets = doc.querySelectorAll('.js-fadein')
    if (!targets.length) return

    const STAGGER_STEP = 100 // ms
    const STAGGER_MAX = 5 // 登場順の連番が大きくなりすぎても待ち時間が長引かないよう上限で頭打ちにする

    targets.forEach((el, index) => {
      const delay = Math.min(index, STAGGER_MAX) * STAGGER_STEP
      el.style.transitionDelay = `${delay}ms`
    })

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            obs.unobserve(entry.target)
          }
        })
      },
      {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: 0,
      }
    )

    targets.forEach((el) => observer.observe(el))
  }

  // フェードイン処理実行
  initFadein()
})(window.document)
